import styled from 'styled-components';

/**
 * Utility component for removing focus styles of parent component on mouse click,
 * while keeping the focus styles on tab navigation. Wrap around any children of the
 * parent component and apply styling to the parent component as usual.
 *
 * **Important:**
 * - **Parent needs `position: relative;`**
 * - **This should be the only child of the parent.**
 * - **Does not cover any borders of the parent element. Try using inset box shadows instead.**
 *
 * All styling should work on the parent.
 * If it doesn't please let #design-platform team know so that we can fix it!
 */
const MouseClickFocusRemover = /*#__PURE__*/styled.span.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "mouse-click-remover__MouseClickFocusRemover",
  componentId: "zettle__sc-1ci5fw8-0"
})(["padding:0;min-height:inherit;height:100%;width:100%;align-self:stretch;justify-self:stretch;border-radius:inherit;display:inherit;align-items:inherit;align-content:inherit;justify-content:inherit;flex-flow:inherit;flex-direction:inherit;flex-wrap:inherit;z-index:1;&:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;z-index:-1;}&:focus{outline:none;&::-moz-focus-inner{border:0;}}"]);

export { MouseClickFocusRemover };
//# sourceMappingURL=mouse-click-remover.js.map
